/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MonitoredObjectMetadata,
    MonitoredObjectMetadataFromJSON,
    MonitoredObjectMetadataFromJSONTyped,
    MonitoredObjectMetadataToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReadOnlyMonitoredObjectV2Serializer
 */
export interface ReadOnlyMonitoredObjectV2Serializer {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    readonly id?: number;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    costPerKm?: object;
    /**
     * 
     * @type {MonitoredObjectMetadata}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    metadata?: MonitoredObjectMetadata;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    readonly deleted?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    externalId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    registrationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    systemDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    manufacturerName?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    _configuration?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    status?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    tankSize?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    customLabel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    vehicleTrainMaxWeight?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    vehicleTractorMaxWeight?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    cng?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    disabledAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    forwardedToDff?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    lastSyncWithDff?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    dffSyncTraceback?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    monitoringDevice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    client: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    monitoredObjectType: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    driverApplication?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    externalSystem?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectV2Serializer
     */
    countryOfRegistration?: number | null;
}

export function ReadOnlyMonitoredObjectV2SerializerFromJSON(json: any): ReadOnlyMonitoredObjectV2Serializer {
    return ReadOnlyMonitoredObjectV2SerializerFromJSONTyped(json, false);
}

export function ReadOnlyMonitoredObjectV2SerializerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoredObjectV2Serializer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'costPerKm': !exists(json, 'cost_per_km') ? undefined : json['cost_per_km'],
        'metadata': !exists(json, 'metadata') ? undefined : MonitoredObjectMetadataFromJSON(json['metadata']),
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'externalId': !exists(json, 'external_id') ? undefined : json['external_id'],
        'registrationNumber': json['registration_number'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'systemDescription': !exists(json, 'system_description') ? undefined : json['system_description'],
        'manufacturerName': !exists(json, 'manufacturer_name') ? undefined : json['manufacturer_name'],
        '_configuration': !exists(json, 'configuration') ? undefined : json['configuration'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'tankSize': !exists(json, 'tank_size') ? undefined : json['tank_size'],
        'customLabel': !exists(json, 'custom_label') ? undefined : json['custom_label'],
        'vehicleTrainMaxWeight': !exists(json, 'vehicle_train_max_weight') ? undefined : json['vehicle_train_max_weight'],
        'vehicleTractorMaxWeight': !exists(json, 'vehicle_tractor_max_weight') ? undefined : json['vehicle_tractor_max_weight'],
        'cng': !exists(json, 'cng') ? undefined : json['cng'],
        'disabledAt': !exists(json, 'disabled_at') ? undefined : (json['disabled_at'] === null ? null : new Date(json['disabled_at'])),
        'forwardedToDff': !exists(json, 'forwarded_to_dff') ? undefined : json['forwarded_to_dff'],
        'lastSyncWithDff': !exists(json, 'last_sync_with_dff') ? undefined : (json['last_sync_with_dff'] === null ? null : new Date(json['last_sync_with_dff'])),
        'dffSyncTraceback': !exists(json, 'dff_sync_traceback') ? undefined : json['dff_sync_traceback'],
        'monitoringDevice': !exists(json, 'monitoring_device') ? undefined : json['monitoring_device'],
        'client': json['client'],
        'monitoredObjectType': json['monitored_object_type'],
        'driverApplication': !exists(json, 'driver_application') ? undefined : json['driver_application'],
        'externalSystem': !exists(json, 'external_system') ? undefined : json['external_system'],
        'countryOfRegistration': !exists(json, 'country_of_registration') ? undefined : json['country_of_registration'],
    };
}

export function ReadOnlyMonitoredObjectV2SerializerToJSON(value?: ReadOnlyMonitoredObjectV2Serializer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cost_per_km': value.costPerKm,
        'metadata': MonitoredObjectMetadataToJSON(value.metadata),
        'external_id': value.externalId,
        'registration_number': value.registrationNumber,
        'description': value.description,
        'system_description': value.systemDescription,
        'manufacturer_name': value.manufacturerName,
        'configuration': value._configuration,
        'note': value.note,
        'status': value.status,
        'tank_size': value.tankSize,
        'custom_label': value.customLabel,
        'vehicle_train_max_weight': value.vehicleTrainMaxWeight,
        'vehicle_tractor_max_weight': value.vehicleTractorMaxWeight,
        'cng': value.cng,
        'disabled_at': value.disabledAt === undefined ? undefined : (value.disabledAt === null ? null : value.disabledAt.toISOString()),
        'forwarded_to_dff': value.forwardedToDff,
        'last_sync_with_dff': value.lastSyncWithDff === undefined ? undefined : (value.lastSyncWithDff === null ? null : value.lastSyncWithDff.toISOString()),
        'dff_sync_traceback': value.dffSyncTraceback,
        'monitoring_device': value.monitoringDevice,
        'client': value.client,
        'monitored_object_type': value.monitoredObjectType,
        'driver_application': value.driverApplication,
        'external_system': value.externalSystem,
        'country_of_registration': value.countryOfRegistration,
    };
}


